import type { TFunction } from "i18next";
import { titleCase } from "title-case";
import CardRequestType from "enums/CardRequestType";

export const cardRequestTypeLabel = (
  type: string | null | undefined,
  t: TFunction,
): string | null => {
  switch (type) {
    case CardRequestType.NEW:
      return t("New Card");
    case CardRequestType.POLICY_UPDATE:
      return t("Policy Update");
    case CardRequestType.REPLACE_LOST:
      return t("Replace Lost");
    case CardRequestType.REPLACE_STOLEN:
      return t("Replace Stolen");
    case CardRequestType.REPLACE_DAMAGED:
      return t("Replace Damaged");
    case CardRequestType.REPLACE_EXPIRED:
      return t("Replace Expired");
    case CardRequestType.LIMIT_INCREASE:
      return t("Limit Increase");
    case CardRequestType.APPROVE_MERCHANT:
      return t("Approve Merchant");
    default:
      return type ? titleCase(type.replace(/_/g, " ").toLowerCase()) : null;
  }
};
